import React from "react"
import { Link } from "gatsby"

import Layout from "layouts/default"
import Header from "components/components/header"
import Button from "components/form/button"
import Seo from "components/search/seo"
import { pipkin, pipkinGame } from "components/search/structured-data"

import * as s from "./pipkin.module.sass"

const PipkinPage = () => (
  <Layout>
    <Seo
      title="Pipkin — Creative Play for Ages 2–7 | Netspeak Games"
      description={pipkin.description}
      path={pipkin.path}
      image={pipkin.image}
      imageAlt={pipkin.imageAlt}
      entities={[pipkinGame]}
    />
    <Header />
    <main className={s.component}>
      <div className={s.container}>
        <Link className={s.back} to="/#games">
          ← Our projects
        </Link>

        <div className={s.hero}>
          <div>
            <p className={s.eyebrow}>Made by Netspeak Games</p>
            <h1 className={s.title}>Pipkin</h1>
            <p className={s.subtitle}>A little world of play for ages 2–7</p>
            <p className={s.introduction}>{pipkin.description}</p>
            <div className={s.actions}>
              <Button href={pipkin.website} color="yellow">
                Visit the official Pipkin website
              </Button>
            </div>
          </div>
          <figure className={s.artwork}>
            <img
              src={pipkin.image}
              alt={pipkin.imageAlt}
              width="944"
              height="554"
            />
            <figcaption>
              Space, painting and sandcastles: places to play in Pipkin.
            </figcaption>
          </figure>
        </div>

        <div className={s.story}>
          <section>
            <h2>Why we’re making Pipkin</h2>
            <p>
              Pipkin began with a simple wish: to make a game we would be happy
              to give our own children. At Netspeak Games, that means making
              room for curiosity, experimentation and play at a child’s own
              pace.
            </p>
            <p>
              We’re bringing our experience of making games to a younger
              audience. Pipkin combines creative activities and exploration,
              from building on the beach to discovering space. It’s inspired by
              the things our children enjoy and the questions they ask.
            </p>
          </section>

          <section>
            <h2>Who makes Pipkin?</h2>
            <p>
              Pipkin is created by Netspeak Games, an independent games studio
              in the UK. Our co-founders, Callum and Simon, are dads as well as
              game makers. Our own children help us test what we’re building.
            </p>
            <p>
              You can meet <Link to="/team/">the Netspeak Games team</Link> and
              read more about <Link to="/#story">our studio’s story</Link>.
            </p>
          </section>

          <section>
            <h2>Designed for young children</h2>
            <p>
              Pipkin is designed for ages 2–7, with touch controls and no
              reading required. There are no ads or popups to interrupt play.
              Grown-up settings and subscriptions sit in a separate Parent Zone.
            </p>
            <p>
              For details about the Parent Zone, privacy and subscriptions, read
              the{" "}
              <a href={pipkin.parentsUrl}>Pipkin parents and safety guide</a>.
            </p>
          </section>

          <section className={s.status}>
            <h2>When can we play?</h2>
            <p>
              Pipkin is currently in development and is not yet published on the
              App Store or Google Play. The official Pipkin website is the place
              for current game details and availability updates.
            </p>
            <a href={pipkin.website}>Explore Pipkin at playpipkin.co.uk →</a>
          </section>
        </div>
      </div>
    </main>
  </Layout>
)

export default PipkinPage
